import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class RiverSpring8TerrainTileEntity extends TileEntity {
	public static readonly frameName = FrameName.RIVER_SPRING8;
}

export default RiverSpring8TerrainTileEntity;
